import React from "react";
import { Box, Button } from "@mui/material";
import QrCode2OutlinedIcon from "@mui/icons-material/QrCode2Outlined";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { MarketplaceAppDownload } from "../mockData/marketplaceMockData";

interface Props {
  vendorName: string;
  appDownload: MarketplaceAppDownload;
}

const VendorAppDownload: React.FC<Props> = ({ vendorName, appDownload }) => {
  const downloadUrl = appDownload.universalUrl || appDownload.androidUrl || appDownload.iosUrl || "";
  const qrImageUrl = downloadUrl
    ? `https://api.qrserver.com/v1/create-qr-code/?size=140x140&margin=6&data=${encodeURIComponent(downloadUrl)}`
    : "";

  return (
    <Box className="vendor_app_download">
      <Box className="vendor_app_download_header">
        <QrCode2OutlinedIcon />
        <Box>
          <h6>Download the app</h6>
          <p>Scan QR or tap store link to install {appDownload.appName || vendorName}</p>
        </Box>
      </Box>

      {qrImageUrl && (
        <Box className="vendor_qr_scanner">
          <Box className="vendor_qr_frame">
            <img src={qrImageUrl} alt={`QR code to download ${vendorName} app`} className="vendor_qr_image" />
          </Box>
          <span className="vendor_qr_hint">Point your phone camera here</span>
        </Box>
      )}

      <Box className="vendor_store_buttons">
        {appDownload.iosUrl && (
          <Button
            variant="outlined"
            className="store_btn ios"
            href={appDownload.iosUrl}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<AppleIcon />}
          >
            App Store
          </Button>
        )}
        {appDownload.androidUrl && (
          <Button
            variant="outlined"
            className="store_btn android"
            href={appDownload.androidUrl}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<AndroidIcon />}
          >
            Google Play
          </Button>
        )}
        {appDownload.universalUrl && (
          <Button
            variant="text"
            className="store_btn web"
            href={appDownload.universalUrl}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<OpenInNewIcon />}
          >
            Open in browser
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default VendorAppDownload;
